import React from 'react';
import styles from './TrustedByBrands.module.css';
import { ReactComponent as TrippleWhale } from 'assets/partners/tripple-whale.svg';
import { ReactComponent as Semrush } from 'assets/partners/semrush.svg';
import { ReactComponent as AgileOffroad } from 'assets/partners/agile-offroad.svg';
import { ReactComponent as Pella } from 'assets/partners/pella.svg';
import { ReactComponent as DellTechnologies } from 'assets/partners/dell-technologies.svg';
import { ReactComponent as Cove } from 'assets/partners/cove.svg';
import { ReactComponent as Hairbrella } from 'assets/partners/hairbrella.svg';

export const TrustedByBrands = () => (
  <div className={styles.wrapper}>
    <p className={styles.text}>Trusted by the World's Most Innovative Brands</p>
    <div className={styles.logos}>
      <TrippleWhale alt="Tripple Whale" width={150} height={20} />
      <Semrush alt="Semrush" width={136} height={18} />
      <AgileOffroad alt="Agile Offroad" width={100} height={32} />
      <Pella alt="Pella" width={63} height={37} />
      <DellTechnologies alt="Dell Technologies" width={157} height={20} />
      <Cove alt="Cove" width={64} height={20} />
      <Hairbrella alt="Hairbrella" width={100} height={20} />
    </div>
  </div>
);
